import i18n from 'i18next';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

const SUPPORTED = ['fr', 'de', 'pl', 'en'];
const LEGACY = {
english: 'en',
german: 'de',
polish: 'pl',
french: 'fr',
};

export const normalizeLanguage = (raw) => {
if (!raw) return 'en';
const lower = String(raw).toLowerCase();
const mapped = LEGACY[lower] || lower.slice(0, 2);
return SUPPORTED.includes(mapped) ? mapped : 'en';
};

const browserLang = typeof navigator !== 'undefined' ? navigator.language : 'en';
const initialLanguage = normalizeLanguage(localStorage.getItem('i18nextLng') || browserLang);

i18n
.use(HttpBackend)
.use(initReactI18next)
.init({
lng: initialLanguage,
fallbackLng: 'en',
supportedLngs: SUPPORTED,
ns: ['common', 'nav', 'header', 'orders', 'proposals','settings', 'notifications', 'auth', 'production', 'ViewOrder', 'ViewProposal', 'AllOrders'],
defaultNS: 'common', 
// 'common' is last so keys addressed with the (nonexistent) 'Common:' namespace
// prefix still resolve to common.json instead of falling back to English defaults
fallbackNS: ['nav', 'header', 'orders', 'settings', 'notifications', 'ViewProposal', 'common'],

interpolation: { escapeValue: false },

backend: {
  loadPath: '/locales/{{lng}}/{{ns}}.json',
},
});

i18n.on('languageChanged', (lng) => {
localStorage.setItem('i18nextLng', normalizeLanguage(lng));
});

export default i18n;